<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 183.7 36.36" style="enable-background:new 0 0 183.7 36.36;" xml:space="preserve"> ll:url(#SVGID_1_);}
        <g>
            <path class="st0" d="M20.87,7.4v21.61c0,0.53-0.43,0.97-0.97,0.97H16.4c-0.53,0-0.97-0.43-0.97-0.97v-8.68H6.05v8.68
                c0,0.53-0.43,0.97-0.97,0.97H1.58c-0.53,0-0.97-0.43-0.97-0.97V7.4c0-0.53,0.43-0.97,0.97-0.97h3.51c0.53,0,0.97,0.43,0.97,0.97
                v8.15h9.38V7.4c0-0.53,0.43-0.97,0.97-0.97h3.51C20.43,6.43,20.87,6.87,20.87,7.4z"/>
            <path class="st0" d="M44.82,25.33c0.93,0,1.71-0.19,2.35-0.58c0.64-0.39,1.16-0.9,1.56-1.54c0.4-0.64,0.68-1.38,0.85-2.2
                c0.17-0.83,0.25-1.67,0.25-2.54V7.4c0-0.53,0.43-0.97,0.97-0.97h3.51c0.53,0,0.97,0.43,0.97,0.97v11.07c0,1.64-0.2,3.16-0.61,4.58
                c-0.41,1.41-1.04,2.65-1.89,3.71c-0.85,1.06-1.93,1.9-3.25,2.5c-1.32,0.61-2.88,0.91-4.69,0.91c-1.88,0-3.48-0.32-4.81-0.96
                c-1.33-0.64-2.4-1.5-3.23-2.57c-0.83-1.07-1.44-2.32-1.82-3.73c-0.39-1.41-0.58-2.9-0.58-4.44V7.4c0-0.53,0.43-0.97,0.97-0.97h3.51
                c0.53,0,0.97,0.43,0.97,0.97v11.07c0,0.91,0.09,1.77,0.27,2.59c0.18,0.82,0.46,1.55,0.86,2.19c0.4,0.64,0.91,1.15,1.54,1.53
                C43.11,25.14,43.89,25.33,44.82,25.33z"/>
            <path class="st0" d="M68.77,28.82V7.59c0-0.64,0.52-1.16,1.16-1.16h7.63c1.94,0,3.65,0.31,5.11,0.93c1.46,0.62,2.68,1.46,3.66,2.52
                c0.98,1.06,1.72,2.3,2.22,3.73c0.5,1.43,0.75,2.95,0.75,4.56c0,1.79-0.28,3.41-0.83,4.86c-0.55,1.45-1.34,2.69-2.37,3.71
                c-1.03,1.03-2.27,1.82-3.71,2.39c-1.45,0.56-3.06,0.85-4.82,0.85h-7.63C69.29,29.97,68.77,29.45,68.77,28.82z M83.75,18.17
                c0-1.04-0.14-1.98-0.41-2.83c-0.28-0.85-0.68-1.59-1.21-2.2c-0.53-0.62-1.18-1.09-1.96-1.43c-0.77-0.33-1.65-0.5-2.62-0.5H74.2
                V25.2h3.35c0.99,0,1.88-0.18,2.65-0.53c0.77-0.35,1.42-0.85,1.94-1.48c0.52-0.63,0.92-1.37,1.19-2.22
                C83.61,20.12,83.75,19.19,83.75,18.17z"/>
            <path class="st0" d="M102.8,28.82V7.59c0-0.64,0.52-1.16,1.16-1.16h7.63c1.94,0,3.65,0.31,5.11,0.93c1.46,0.62,2.68,1.46,3.66,2.52
                c0.98,1.06,1.72,2.3,2.22,3.73c0.5,1.43,0.75,2.95,0.75,4.56c0,1.79-0.28,3.41-0.83,4.86c-0.55,1.45-1.34,2.69-2.37,3.71
                c-1.03,1.03-2.27,1.82-3.71,2.39c-1.45,0.56-3.06,0.85-4.82,0.85h-7.63C103.31,29.97,102.8,29.45,102.8,28.82z M117.78,18.17
                c0-1.04-0.14-1.98-0.41-2.83c-0.28-0.85-0.68-1.59-1.21-2.2c-0.53-0.62-1.18-1.09-1.96-1.43c-0.77-0.33-1.65-0.5-2.62-0.5h-3.35
                V25.2h3.35c0.99,0,1.88-0.18,2.65-0.53c0.77-0.35,1.42-0.85,1.94-1.48s0.92-1.37,1.19-2.22C117.64,20.12,117.78,19.19,117.78,18.17
                z"/>
            <path class="st0" d="M182.7,26.26v2.84c0,0.53-0.43,0.97-0.97,0.97h-14.42c-0.64,0-1.16-0.52-1.16-1.16V7.69
                c0-0.64,0.52-1.16,1.16-1.16h14.12c0.53,0,0.97,0.43,0.97,0.97v2.84c0,0.53-0.43,0.97-0.97,0.97h-9.84v4.58h8.32
                c0.53,0,0.97,0.43,0.97,0.97v2.48c0,0.53-0.43,0.97-0.97,0.97h-8.32v5.01h10.14C182.26,25.3,182.7,25.73,182.7,26.26z"/>
            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="133.7112" y1="17.9848" x2="155.2182" y2="17.9848">
                <stop  offset="0" style="stop-color:#8FFFF7"/>
                <stop  offset="1" style="stop-color:#14FBF0"/>
            </linearGradient>
            <polygon class="st1" points="155.22,35.36 146.9,35.36 133.71,0.61 142.03,0.61 	"/>
        </g>
    </svg>
</template>

<script>
export default {
    data: function(){
        return{
            colors: {}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    }
}
</script>

<style lang="scss" scoped>
	.st0{fill:#FFFFFF;}
	.st1{fill:url(#SVGID_1_);}
</style>